import userReducer from "./userReducer";
import apartmentReducer from "./apartmentReducer";

const StaticReducers = {
  userState: userReducer,
  apartmentState: apartmentReducer,
};

export default StaticReducers;